import { useState } from "react"
import { Project } from "./useProjectsList";

// export const useEditProjectAttribute = (updateProject: (projectId: string, changes: Partial<Project>) => Promise<Project>) => {
//   const [editing, setEditing] = useState<{ projectId: string, field: string, value: string, isSaving?: boolean } | null>(null);


//   const complete = () => {
//     if(editing) {
//       const projectId = editing.projectId;
//       const changes = { [editing.field]: editing.value };
//       setEditing(x => x ? { ...x, isSaving: true } : x);
//       return updateProject(projectId, changes)
//         .then(x => setEditing(null))
//         .catch(e => {
//           setEditing(null);
//           throw e;
//         });
//     }
//   }

//   return {
//     cancel: () => setEditing(null),
//     complete,
//     editing,
//     startEditing: (projectId: string, field: string, value: string) => {
//       setEditing({ projectId, field, value });
//     },
//     update: (v: string) => {
//       setEditing(x => x ? ({ ...x, value: v }) : x);
//     },
//   }
// }

export const useEditRecordAttribute = <T>(updateRecord: (recordId: string, changes: Partial<T>) => Promise<T>) => {
  const [editing, setEditing] = useState<{ recordId: string, field: string, value: string, isSaving?: boolean } | null>(null);


  const complete = () => {
    if(editing) {
      const projectId = editing.recordId;
      const changes = { [editing.field]: editing.value };
      setEditing(x => x ? { ...x, isSaving: true } : x);
      return updateRecord(projectId, changes as any)
        .then(x => setEditing(null))
        .catch(e => {
          setEditing(null);
          throw e;
        });
    }
  }

  return {
    cancel: () => setEditing(null),
    complete,
    editing,
    startEditing: (recordId: string, field: string, value: string) => {
      setEditing({ recordId, field, value });
    },
    update: (v: string) => {
      setEditing(x => x ? ({ ...x, value: v }) : x);
    },
  }
}

export const useEditProjectAttribute = (updateProject: (projectId: string, changes: Partial<Project>) => Promise<Project>) => {
  return useEditRecordAttribute<Project>(updateProject);
}

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export type EditRecordAttributeData<T> = ReturnType<typeof useEditRecordAttribute>;
export type EditProjectAttributeData = ReturnType<typeof useEditProjectAttribute>;
